(function () {
  var cache = new Map();

  // Announce a settled parts-finder search so the analytics layer (snippets/sewphee-analytics.liquid)
  // can emit `fitment_search` without this file depending on it. Fires on results render and on a
  // full-page search submit — never per keystroke. De-duped on query so a cache-hit re-render of the
  // same term does not re-announce.
  var lastFitmentQuery = null;
  function announceFitmentSearch(query, resultsCount) {
    var q = (query || '').trim();
    if (!q || q === lastFitmentQuery) return;
    lastFitmentQuery = q;
    try {
      document.dispatchEvent(
        new CustomEvent('sewphee:fitment-search', {
          detail: {
            query: q,
            results_count: typeof resultsCount === 'number' ? resultsCount : null
          }
        })
      );
    } catch (e) {
      // CustomEvent constructor unsupported (very old browsers) — skip silently.
    }
  }

  function debounce(callback, delay) {
    var timer;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(null, args);
      }, delay);
    };
  }

  function money(value, format) {
    var numeric = Number(value);
    if (!Number.isFinite(numeric)) return value || '';

    var cents = Math.round(numeric * 100);
    var placeholder = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    var decimal = '.';
    var thousands = ',';
    var precision = 2;

    if (placeholder === 'amount_no_decimals') precision = 0;
    if (placeholder === 'amount_with_comma_separator') {
      decimal = ',';
      thousands = '.';
    }
    if (placeholder === 'amount_no_decimals_with_comma_separator') {
      precision = 0;
      decimal = ',';
      thousands = '.';
    }
    if (placeholder === 'amount_with_apostrophe_separator') thousands = "'";

    var number = (cents / 100).toFixed(precision);
    var pieces = number.split('.');
    pieces[0] = pieces[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var output = pieces[0] + (pieces[1] ? decimal + pieces[1] : '');

    return format.replace(/\{\{\s*\w+\s*\}\}/, output);
  }

  function imageUrl(product) {
    var image = product.featured_image;
    if (!image) return '';
    var url = typeof image === 'string' ? image : image.url || image.src || '';
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '_540x$1$2');
  }

  function matchingVariant(product, query) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var needle = query.toLowerCase();
    var match = variants.find(function (variant) {
      return String(variant.sku || '').toLowerCase().indexOf(needle) !== -1;
    });
    return match || variants[0] || null;
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function productCard(root, product, query) {
    var card = element('article', 'pf__product');
    var media = element('a', 'pf__product-media');
    media.href = product.url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');

    var source = imageUrl(product);
    if (source) {
      var image = element('img', 'pf__product-image');
      image.src = source;
      image.alt = product.featured_image && product.featured_image.alt
        ? product.featured_image.alt
        : product.title;
      image.loading = 'lazy';
      image.width = 540;
      media.appendChild(image);
    } else {
      media.appendChild(element('span', 'pf__product-image pf__product-image--empty'));
    }

    if (product.available === false) {
      media.appendChild(element('span', 'pf__product-badge', root.dataset.soldText));
    }
    card.appendChild(media);

    var body = element('div', 'pf__product-body');
    if (root.dataset.showVendor === 'true' && product.vendor) {
      body.appendChild(element('p', 'pf__product-vendor', product.vendor));
    }

    var title = element('h4', 'pf__product-title');
    var titleLink = element('a', '', product.title);
    titleLink.href = product.url;
    title.appendChild(titleLink);
    body.appendChild(title);

    var variant = matchingVariant(product, query);
    if (root.dataset.showSku === 'true' && variant && variant.sku) {
      body.appendChild(element('p', 'pf__product-code', root.dataset.codeText + ' ' + variant.sku));
    }
    if (root.dataset.showType === 'true' && product.type) {
      body.appendChild(element('p', 'pf__product-type', product.type));
    }

    var bottom = element('div', 'pf__product-bottom');
    if (root.dataset.showPrice === 'true' && product.price !== undefined) {
      var price = element('p', 'pf__product-price');
      price.appendChild(element('span', '', money(product.price, root.dataset.moneyFormat)));

      var compare = Number(product.compare_at_price);
      if (Number.isFinite(compare) && compare > Number(product.price)) {
        price.appendChild(element('s', '', money(compare, root.dataset.moneyFormat)));
      }
      bottom.appendChild(price);
    }

    var arrow = element('a', 'pf__product-link');
    arrow.href = product.url;
    arrow.setAttribute('aria-label', root.dataset.viewText + ': ' + product.title);
    arrow.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12h15m0 0-6-6m6 6-6 6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    bottom.appendChild(arrow);
    body.appendChild(bottom);
    card.appendChild(body);

    return card;
  }

  function resultProducts(payload) {
    if (!payload || !payload.resources || !payload.resources.results) return [];
    return payload.resources.results.products || [];
  }

  function setup(root) {
    if (root.dataset.pfReady === 'true') return;
    root.dataset.pfReady = 'true';

    var form = root.querySelector('[data-pf-form]');
    var input = root.querySelector('[data-pf-input]');
    var clear = root.querySelector('[data-pf-clear]');
    var results = root.querySelector('[data-pf-results]');
    var grid = root.querySelector('[data-pf-grid]');
    var status = root.querySelector('[data-pf-status]');
    var empty = root.querySelector('[data-pf-empty]');
    var count = root.querySelector('[data-pf-count]');
    var emptyText = root.querySelector('[data-pf-empty-text]');
    var kicker = root.querySelector('[data-pf-kicker]');
    var title = root.querySelector('[data-pf-title]');
    var allLink = root.querySelector('[data-pf-all]');
    var examples = root.querySelectorAll('[data-pf-example]');
    var minimum = Number(root.dataset.minChars) || 2;
    var limit = Math.min(Number(root.dataset.limit) || 8, 10);
    var initialGrid = grid.innerHTML;
    var initialKicker = kicker.textContent;
    var initialTitle = title.textContent;
    var controller = null;
    var requestNumber = 0;

    // Skeleton cards hold the grid height steady so the page does not jump
    // between keystrokes.
    function showSkeletons(query) {
      var placeholders = Math.min(limit, 4);
      grid.innerHTML = '';
      delete grid.dataset.live;

      for (var i = 0; i < placeholders; i++) {
        var card = element('article', 'pf__product pf__skeleton');
        card.style.setProperty('--i', String(i));
        card.appendChild(element('span', 'pf__skeleton-media'));

        var body = element('div', 'pf__skeleton-body');
        body.appendChild(element('span', 'pf__skeleton-line pf__skeleton-line--short'));
        body.appendChild(element('span', 'pf__skeleton-line'));
        body.appendChild(element('span', 'pf__skeleton-line pf__skeleton-line--half'));
        card.appendChild(body);
        grid.appendChild(card);
      }

      grid.hidden = false;
      empty.hidden = true;
      status.hidden = true;
      count.hidden = true;
      kicker.textContent = root.dataset.resultsText;
      title.textContent = root.dataset.loadingText;
      results.setAttribute('aria-busy', 'true');
      if (query) allLink.hidden = true;
    }

    function stopLoading() {
      results.setAttribute('aria-busy', 'false');
    }

    function restore() {
      if (controller) controller.abort();
      requestNumber += 1;
      grid.innerHTML = initialGrid;
      delete grid.dataset.live;
      grid.hidden = false;
      status.hidden = true;
      empty.hidden = true;
      allLink.hidden = true;
      count.hidden = true;
      kicker.textContent = initialKicker;
      title.textContent = initialTitle;
      stopLoading();
      input.setAttribute('aria-expanded', 'false');
    }

    function showMessage(message) {
      stopLoading();
      grid.hidden = true;
      empty.hidden = true;
      count.hidden = true;
      status.textContent = message;
      status.hidden = false;
    }

    function render(products, query) {
      stopLoading();
      grid.innerHTML = '';
      status.hidden = true;
      kicker.textContent = root.dataset.resultsText;
      title.textContent = 'Results for “' + query + '”';
      allLink.href = root.dataset.searchUrl + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
      allLink.hidden = false;

      if (!products.length) {
        grid.hidden = true;
        count.hidden = true;
        empty.hidden = false;
        emptyText.textContent = root.dataset.noResults;
        input.setAttribute('aria-expanded', 'true');
        announceFitmentSearch(query, 0);
        return;
      }

      count.textContent = products.length + (products.length === 1 ? ' match' : ' matches');
      count.hidden = false;

      announceFitmentSearch(query, products.length);

      var fragment = document.createDocumentFragment();
      products.forEach(function (product, index) {
        var card = productCard(root, product, query);
        card.style.setProperty('--i', String(index));
        fragment.appendChild(card);
      });
      grid.appendChild(fragment);
      grid.dataset.live = 'true';
      grid.hidden = false;
      empty.hidden = true;
      input.setAttribute('aria-expanded', 'true');
    }

    function search(rawQuery) {
      var query = rawQuery.trim();
      clear.hidden = query.length === 0;

      if (query.length === 0) {
        restore();
        return;
      }

      if (query.length < minimum) {
        if (controller) controller.abort();
        requestNumber += 1;
        allLink.hidden = true;
        kicker.textContent = root.dataset.resultsText;
        showMessage('Enter at least ' + minimum + ' characters to search.');
        title.textContent = 'Keep typing';
        return;
      }

      var cacheKey = query.toLowerCase();
      if (cache.has(cacheKey)) {
        render(cache.get(cacheKey), query);
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();
      var thisRequest = ++requestNumber;
      showSkeletons(query);

      var params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', String(limit));
      params.set('resources[options][unavailable_products]', 'last');
      params.set('resources[options][fields]', 'title,product_type,variants.title,variants.sku,vendor,tag');

      fetch(root.dataset.predictiveUrl + '?' + params.toString(), {
        signal: controller.signal,
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('search-failed');
          return response.json();
        })
        .then(function (payload) {
          if (thisRequest !== requestNumber) return;
          var products = resultProducts(payload);
          cache.set(cacheKey, products);
          render(products, query);
        })
        .catch(function (error) {
          if (error.name === 'AbortError' || thisRequest !== requestNumber) return;
          showMessage(root.dataset.errorText);
          allLink.href = root.dataset.searchUrl + '?type=product&q=' + encodeURIComponent(query);
          allLink.hidden = false;
        });
    }

    var debouncedSearch = debounce(search, 260);
    input.addEventListener('input', function () {
      clear.hidden = input.value.length === 0;
      debouncedSearch(input.value);
    });

    clear.addEventListener('click', function () {
      input.value = '';
      clear.hidden = true;
      restore();
      input.focus();
    });

    examples.forEach(function (button) {
      button.addEventListener('click', function () {
        input.value = button.dataset.pfExample;
        clear.hidden = false;
        search(input.value);
        input.focus();
      });
    });

    form.addEventListener('submit', function (event) {
      if (!input.value.trim()) {
        event.preventDefault();
        input.focus();
        return;
      }
      // Full-page search submit. results_count is unknown here (the search results page owns it).
      announceFitmentSearch(input.value, null);
    });

    if (
      root.dataset.reveal === 'true' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
      'IntersectionObserver' in window
    ) {
      root.classList.add('pf--armed');
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            root.classList.add('is-in');
            observer.disconnect();
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
      observer.observe(root);
    } else {
      root.classList.add('is-in');
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pf]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
